const windowWidth = {
    data () {
        return {
            windW: '' // 
        }
    },
    mounted(){

        this.getWidth()

        jQuery(document).on("ini-ready", ()=>{
            this.getWidth()
        })

        jQuery(document).on("window-resized", ()=>{
            this.getWidth()
        });

    },
    methods:{
        getWidth(){
            this.windW = api.vars.windW
        }
    }
}